import { inject, Injectable } from '@angular/core';
import { PuHistorikDatasource } from '@features/pensionsudbydere/pu-historik/pu-historik.datasource';

@Injectable({
  providedIn: 'root'
})
export class PensionsudbyderHistorikService  {
  datasource = inject(PuHistorikDatasource);
}
